import classNames from "classnames";
import useBreakpoints from "neetocommons/react-utils/useBreakpoints";
import { RightArrow } from "neetoicons";
import { Button, Typography } from "neetoui";
import { Trans, useTranslation } from "react-i18next";

import { GENERAL_ONBOARDING_STEPS } from "./constants";

const HelpScreen = ({ setCurrentStep, helpScreenClassName }) => {
  const { t } = useTranslation();
  const { isSize } = useBreakpoints();

  return (
    <div
      className={classNames(
        "mx-auto flex w-full max-w-3xl flex-col items-start gap-y-6 px-6 pb-6 pt-16",
        helpScreenClassName
      )}
    >
      <div className="flex flex-col gap-y-3">
        <Typography
          component="h1"
          data-testid="onboarding-help-title"
          style="h1"
        >
          {t("neetoMolecules.onboarding.helpScreen.title")}
        </Typography>
        <Typography
          data-testid="onboarding-help-description"
          lineHeight="normal"
          style="body1"
        >
          <Trans i18nKey="neetoMolecules.onboarding.helpScreen.description" />
        </Typography>
        <div className="w-full pt-3">
          {isSize("mobile") ? (
            <img
              alt=""
              src="https://ik.imagekit.io/d9mvewbju/Commons/NeetoMolecules/help-support-mobile_fgsI9Cx-IC.svg"
            />
          ) : (
            <img
              alt=""
              src="https://ik.imagekit.io/d9mvewbju/Commons/NeetoMolecules/help-support-desktop_CSOh3DrKTR.svg"
            />
          )}
        </div>
      </div>
      <Button
        data-testid="onboarding-help-button"
        icon={() => <RightArrow className="rtl:scale-x-[-1]" size={16} />}
        iconPosition="right"
        label={t("neetoMolecules.onboarding.helpScreen.continueButton")}
        onClick={() => setCurrentStep(GENERAL_ONBOARDING_STEPS.FINISH)}
      />
    </div>
  );
};

export default HelpScreen;
